<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    center
    title="结算明细--引入应付费用"
    width="80%"
    append-to-body
  >
    <div class="dialog-content">
      <SiruiSearch
        ref="baseInfoFormRef"
        :query="query"
        :columns="formColumn"
        labelWidth="120px"
        @resetBtnClick="resetBtnClickHandler"
        @searchBtnClick="queryBtnClickHandler"
      ></SiruiSearch>
      <!-- <vxe-grid
        border
        show-overflow
        resizable
        ref="settleAccountsRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        height="300"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
        >
        </vxe-table-column>
      </vxe-grid> -->
      <sirui-table
        ref="siruiTable"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :showToolbar="false"
        :columns="tableColumnList"
        :checkbox-config="{ checkMethod: checCheckboxkMethod2 }"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" width="50" title="序号"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</template>
            <template v-else-if="item.field === 'productType'">{{
              productList?.find((item) => item.value == row['productType'])?.label
            }}</template>
            <template v-else-if="item.field === 'serviceType'">{{
              serviceAllList?.find((item) => item.value == row['serviceType'])?.label
            }}</template>
            <template v-else-if="item.field === 'processStatus'">{{
              row.processStatus == '0' ? '未处理' : '已处理'
            }}</template>
            <template v-else-if="item.field === 'multiBillingRuleFlag'">{{
              row.multiBillingRuleFlag == '0' ? '否' : '是'
            }}</template>
            <template v-else-if="item.field === 'isIndividualPartner'">{{
              row.isIndividualPartner == '0' ? '否' : '是'
            }}</template>
            <template v-else-if="item.field === 'confirmStatus'">{{
              ['01'].includes(row.confirmStatus) ? '待确认' : '已确认'
            }}</template>
            <template v-else-if="item.field === 'expenseType'">{{
              expenseTypeList?.find((item) => item.value == row['expenseType'])?.label
            }}</template>
            <template v-else-if="item.field === 'expenseNo'">
              <div style="color: #16a8e1; cursor: pointer">{{ row[item.field] }}</div>
            </template>
            <template v-else-if="item.field === 'createMethod'">{{
              row.createMethod == '01' ? '系统' : '手动'
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHandler" size="small">确认引入</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { formFields, tableColumnList } from './index.js';
  import PAYABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  // import mulTransportMixin from '../../../index.js';
  export default {
    name: 'DeductionTableDialog',
    // mixins: [mulTransportMixin],
    data() {
      return {
        tableColumnList,
        dialogVisible: false,
        loading: false,
        query: {
          contractNo: '', //合同编号
          expenseNoLike: '', //expenseNoLike
          expenseType: '', //expenseType
          businessCategory: '03',
          processStatus: 0,
          businessDateStart: '', //费用生成日期从
          businessDateEnd: '', //费用生成日期至
          businessCompanyName: '',
          businessCompanyNo: '',
          businessDepartmentCode: '',
          businessDepartmentName: '',
        },
        idList: [],
        tableData: [],
        companyList: [],
        departmentList: [],
        selectionList: [],
        productList: [],
        serviceAllList: [],
        serviceList: [],
        lineDetailsList: [],
      };
    },
    mounted() {
      this.$nextTick(() => {});
    },
    methods: {
      checCheckboxkMethod2({ row }) {
        let ids = this.lineDetailsList.map((item) => item.id);
        return !ids.includes(row.id);
      },
      openModal() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getTableData();
        });
      },
      cancelHandler() {
        this.dialogVisible = false;
      },
      confirmHandler() {
        if (this.selectionList.length) {
          this.$emit('confirmHandler', this.selectionList);
          this.cancelHandler();
        } else {
          this.$message.error('请选择行');
        }
      },
      handleSelectionChange(row) {
        console.log(row, 'row');
        this.selectionList = row;
        // this._computedAmount(selection);
      },
      // 表底合并
      footerMethod({ columns }) {
        const footerData = [
          columns.map((column, _columnIndex) => {
            if (_columnIndex === 2) {
              return '合计';
            }
            if (column.property === 'domesticAmount') {
              return 0;
            }
            return null;
          }),
        ];
        return footerData;
      },
      // 计算选中金额
      _computedAmount(selection) {
        const amount = selection.reduce((prev, cur) => prev + cur.domesticAmount, 0);
        const allTdDom = document.querySelector('.vxe-footer--row').querySelectorAll('td');
        const totalDom = allTdDom[allTdDom.length - 2];
        totalDom.querySelector('.vxe-cell').innerHTML = amount;
      },
      // 获取表格数据
      async getTableData() {
        console.log('搜索');
        // this.tableData = this.mockDataList;
        this.loading = true;
        const postData = {
          ...this.query,
          processStatus: this.query.processStatus == null ? null : +this.query.processStatus,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        const { data } = await this.$axios.post(PAYABLES_TRADE.PAYABLEEXPENSE_QUERY, postData);
        console.log(data, '应收费用清单');
        this.loading = false;
        this.tableData = data.data?.records.filter((item) => !this.idList.includes(item.id));
        this.$refs.siruiTable.setPageTotal(this.tableData.length);
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索', this.query);
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        // this.idList = [];
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.query = {
          ...this.query,
          businessCompanyNo: this.userInfo.companyCode,
          businessDepartmentCode: this.userInfo?.departmentCode,
        };
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
    },
    computed: {
      formColumn() {
        return formFields();
      },
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
      expenseTypeList() {
        return [{ value: '01', label: '押金' }];
      },
    },
  };
</script>

<style lang="scss" scoped></style>
